import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { FiShoppingCart, FiMenu, FiX } from "react-icons/fi";
import { getImageUrl } from "../services/api";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const { getCartCount } = useCart();
  const location = useLocation();

  useEffect(() => {
    setLogoUrl(getImageUrl("logo"));
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="logo">
          <img src={logoUrl} alt="Personal Regrets" className="logo-img" />
        </Link>

        <div className={`nav-links ${isOpen ? "active" : ""}`}>
          <Link to="/" onClick={() => setIsOpen(false)} className={location.pathname === "/" ? "active" : ""}>
            Accueil
          </Link>
          <Link to="/shop" onClick={() => setIsOpen(false)} className={location.pathname === "/shop" ? "active" : ""}>
            Boutique
          </Link>
          <Link to="/about" onClick={() => setIsOpen(false)} className={location.pathname === "/about" ? "active" : ""}>
            À propos
          </Link>
          <Link to="/extra" onClick={() => setIsOpen(false)} className={location.pathname === "/extra" ? "active" : ""}>
            Extra
          </Link>
        </div>

        <div className="nav-actions">
          <Link to="/cart" className="cart-icon">
            <FiShoppingCart />
            {getCartCount() > 0 && (
              <span className="cart-badge">{getCartCount()}</span>
            )}
          </Link>

          <button className="menu-toggle" onClick={toggleMenu}>
            {isOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
